import React from 'react';

import { AccountOverviewTab as LegacyAccountOverviewTab } from 'views/account/AccountOverviewTab';

import { AccountOverviewTab } from './AccountOverviewTab';
import { useAccountPageView } from './useAccountPageView';

export const AccountOverviewRoute = () => {
    const { view } = useAccountPageView();
    return view === 'new' ? <AccountOverviewTab /> : <LegacyAccountOverviewTab />;
};
